import { useSearchParamOpener } from "@/v1-console/components/component.utils"

export function useMapLayerPanel() {
  return useSearchParamOpener("layerPanel")
}
